import { render, staticRenderFns } from "./_base-image-uploader.vue?vue&type=template&id=2a951e3e&scoped=true"
import script from "./_base-image-uploader.vue?vue&type=script&lang=js"
export * from "./_base-image-uploader.vue?vue&type=script&lang=js"
import style0 from "./_base-image-uploader.vue?vue&type=style&index=0&id=2a951e3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a951e3e",
  null
  
)

export default component.exports